import React, {useRef} from 'react';
import MainWrapper from "../menu/main";
import {Units} from "../menu/units";
import smoothscroll from 'smoothscroll-polyfill';
import {Upload} from "./upload";
import * as api from "../../api/skyduck";
import {getDictionaries} from "../../storage/user";
import * as ReactGA from "react-ga";

class UploadScreen extends React.Component {
    constructor(props) {
        super(props);

        if(getDictionaries()) {
            this.state = {
                loading: false
            };
        } else {
            this.state = {
                loading: true
            };
        }
    }

    async componentDidMount() {
        if(this.state.loading) {
            await api.dictionaries().then(() => {
                this.setState({
                    loading: false
                });
            })
        }
    }

    render() {
        ReactGA.pageview('/upload');
        return (
            <MainWrapper menu={<Menu/>} content={<Content {...this}/>}/>
        )
    }
}

function Menu() {
    return (
        <>
            <h3 className="skyduck-color">Add jumps</h3>

            {/*<p>You can upload your jump tracks from supported altimeters or add records to logbook manually via form or CSV file.</p>*/}

            <p>You can upload your jump tracks to logbook manually via form or spreadsheet.</p>

            <div className="mt-3">
                <Units/>
            </div>
        </>
    );
}

function Content(props) {
    const messagesEndRef = useRef();

    const scrollToBottom = () => {
        smoothscroll.polyfill();
        messagesEndRef.current.scrollIntoView({
            behavior: 'smooth' , block: 'start', inline: 'nearest'
        })
    }

    return (
        <>
            {props.state.loading
                ? <LoadingSpinner/>
                : <>
                    <Upload scrollToBottom={scrollToBottom}/>
                    <div ref={messagesEndRef} />
                </>}
        </>
    );
}

function LoadingSpinner() {
    return (
        <>
            <p>Setting up dropzones. Please wait a moment.</p>
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Setting up dropzones. Please wait a moment.</span>
            </div>
        </>
    );
}

export default UploadScreen;